// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty-state[data-v-7ef973b1]{display:flex;justify-content:space-between;align-items:flex-start;align-self:stretch}.empty-state__text[data-v-7ef973b1]{margin:0;padding-top:16px;padding-inline-start:16px;width:100%;border-top:1px solid #222c38;color:var(--text-text-high,#fff);font-size:16px;line-height:24px;letter-spacing:.24px}", ""]);
// Exports
module.exports = exports;
